import React  from 'react';
import Typography from '@mui/material/Typography'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { makeStyles } from '@mui/styles';
import { green, grey } from '@mui/material/colors';
import { useRecoilValue } from 'recoil';
import { rulesPasswordState } from 'src/Patient/state/atoms';
import clsx from 'clsx';

const RulesPasswordCreate = () => {
    const classes = useStyles();
    const rulesPassword = useRecoilValue(rulesPasswordState);

    const concatClassSuccess = clsx(classes.icon, classes.success);

    return (
        <>
            <Typography className={classes.root} variant="body2">
                <CheckCircleIcon 
                    className={rulesPassword.lengthIsValid ? concatClassSuccess : classes.icon} 
                /> Debe tener al menos 8 caracteres.
            </Typography>

            <Typography className={classes.root} variant="body2">
                <CheckCircleIcon 
                    className={rulesPassword.upperCaseLetterIsValid ? concatClassSuccess : classes.icon} 
                /> Debe contener al menos una letra mayúscula.
            </Typography>

            <Typography className={classes.root} variant="body2">
                <CheckCircleIcon 
                    className={rulesPassword.lowerCaseLetterIsValid ? concatClassSuccess : classes.icon} 
                /> Debe contener al menos una letra minúscula.
            </Typography>

            <Typography className={classes.root} variant="body2">
                <CheckCircleIcon 
                    className={rulesPassword.findOneNumberIsValid ? concatClassSuccess : classes.icon} 
                /> Debe contener al menos un número.
            </Typography>
        </>
    )
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        padding: 2,
        color: grey[600]
    },
    icon: {
        marginRight: 5,
    },
    success: {
        color: green[600]
    }
})

export default RulesPasswordCreate
